export const successummitnewdatosinquilino = {
    data: {
        leadId: "00QD5000009tCp2MAE",
        quotesResponse: {
                ARRENDAMIENTO_PlanEsencial: "707D600003qZDEkIAO",
                ARRENDAMIENTO_PlanPlus: "707D600003qZDElIAO",
                ARRENDAMIENTO_ArmaTuPlan: "707D600003qZDbvIAG"
          }
     },
    error: false,
    URLRetomaInquilino: "https://arriendolab.ecomm.sura.co/seguros/s/hogar/arriendo/inquilino/resumen-proceso?quoteId=uXkrC53czm5bhcAwfee2lqwMoosjlPRckM%2F%2BuYOXrRcBXqU5CpvQaauEsN%2B0HZO722n77wU4g6gj2oo7XJV5pw%3D%3D"
}